

<template>
	<div class="clp-dialog" v-if="show" 
		:class="{'clp-dialog--tablet-white': this.tablet === 'white'}"
		tabindex="0"
		@keydown.esc="$emit('close')"
		@click.self="$emit('close')"
	>
		<div class="clp-dialog__content">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false
		},
		tablet: {
			type: String,
			default: 'half_gray'
		}
	}
}
</script>
<style lang="scss">
@import "@/create/assets/scss/style.scss";
</style>
